import { defineStore } from 'pinia'

export const useWindBaseDataStore = defineStore('temp', {
    state: () => {
        return {
            data: {},
            project_name: { value: '' }
        }
    },

    actions: {
        getData(name_array) {
            let data = []
            for (let i = 0; i < name_array.length; i++) {
                data.push(
                    this.data[name_array[i]]
                )
            }
            return data
        }
    }


})

